import { useState, useEffect } from "react";
import { Search } from "lucide-react";
import useClickOutside from "../../../CustomHooks/useClickOutside";
import sortDataByAlphabetically from "../../../functions/sorting/sortDataByAlphabetically";
import { Controller } from "react-hook-form";
import { CylinderFillStatus } from "../../../features/cylinder/utils/CylinderStatusOverview";

const CylinderDropdown = ({
  label,
  name,
  options,
  setValue,
  error,
  fieldsCylinderArr,
  control,
}) => {
  const getSerialNumberById = (id) => {
    const cylinder = options.find((item) => item.id === id);
    return cylinder ? cylinder.serialNumber : "";
  };
  const sortedOptions = sortDataByAlphabetically(options, ["serialNumber"]);
  const [searchList, setSearchList] = useState(sortedOptions);
  const [open, setOpen] = useState(-1);
  const { dropdownRef } = useClickOutside(() => setOpen(-1));

  const handleShowDropdown = () => {
    setOpen((prevIndex) => (prevIndex === 1 ? -1 : 1));
  };
  const handleOptionClick = (id) => {
    setValue(name, id, { shouldValidate: true });
    setOpen(-1);
  };

  const handleSearch = (e) => {
    let value = e.target.value;
    if (value.length) {
      const filter = options.filter(
        (item) =>
          item.serialNumber
            .toString()
            .toLowerCase()
            .includes(value.toString().toLowerCase()) ||
          item.size.toString().includes(value.toString())
      );
      setSearchList(sortDataByAlphabetically(filter, ["serialNumber"]));
    } else {
      setSearchList(sortedOptions);
    }
  };

  useEffect(() => {
    setSearchList(sortedOptions);
  }, [options]);

  return (
    <div className="relative">
      <label className="font-poppins text-gray-500 text-xs lg:text-sm">{label}</label>
      <div className="relative" ref={dropdownRef}>
        <p onClick={() => handleShowDropdown()}>
          <Controller
            control={control}
            name={name}
            defaultValue="" // Ensures no default selection
            rules={{
              validate: (value) => value !== "" || "Please select cylinder no.",
            }}
            render={({ field }) => (
              <>
                <span
                  className={`font-poppins absolute right-2 top-2 lg:top-3 cursor-pointer font-semibold ${
                    open === 1 ? "rotate-90" : "rotate-90n"
                  }`}
                >{`<`}</span>
                {field.value !== "" && (
                  <span className="text-xs lg:text-sm font-figtree absolute left-2 lg:left-3 top-[10px] lg:top-3 bg-white w-20">
                    {getSerialNumberById(field.value)}
                  </span>
                )}
                <input
                  name={name}
                  type="text"
                  readOnly="readonly"
                  placeholder="Select"
                  onChange={() => field.onChange(field.value)}
                  className={`dropdown-li-search ${
                    error ? "border-red-500" : "border-lg4"
                  }`}
                  disabled={false}
                />
              </>
            )}
          />
        </p>
        <div
          className={`checksOptionWrap ${
            open === 1 ? "grid opacity-1" : "opacity-0 hidden"
          }`}
        >
          <p className="mb-2">
            <input
              type="text"
              placeholder="Search"
              onChange={handleSearch}
              className="cy-search-inp"
            />
            <Search size={16} className="absolute right-4 top-4" />
          </p>

          {searchList.length > 0 ? (
            <ul
              className={`${
                searchList.length > 6 ? "overflow-y-scroll h-40" : ""
              }`}
            >
              {searchList.map((item, index) => {
                return (
                  <li
                    onClick={() => handleOptionClick(item.id)}
                    className={`dropdown-li flex justify-between ${
                      fieldsCylinderArr?.includes(item.id)
                        ? "bg-lg6 pointer-events-none opacity-40"
                        : ""
                    }`}
                    key={index}
                  >
                    {item.serialNumber}
                    <span className="flex">
                      <p className="w-14">
                        <CylinderFillStatus
                          status={
                            item.currentState
                              ? item.currentState.isFilled
                              : item.isFilled
                          }
                        />
                      </p>
                      {item.size && (
                        <span className="cy-dropdown-size">{`${item.size}kg`}</span>
                      )}
                    </span>
                  </li>
                );
              })}
            </ul>
          ) : (
            <p className="cy-dropdown-search-err">Not Found</p>
          )}
        </div>
        <p className={`input-err ${error ? "visible" : "invisible"}`}>
          {error?.message}
        </p>
      </div>
    </div>
  );
};

export default CylinderDropdown;
